import http from 'axios'

export default {
    state: {
      currentProcessId : null
    },
    mutations: {
        setCurrentProcessId(state,id){
            state.currentProcessId = id
        }
    },
    actions: {
        async initProcess({commit,rootState},formData){
            const { data } = await http.post('/api/process/init',formData,{
                headers:{Authorization:rootState.auth.token}
            });
            commit('setCurrentProcessId',data.processId);
            this._vm.$socket.emit('join',data.processId)
        }
    },
    namespaced: true
}